import styles from "./SelectStudioForm.module.scss";
import { FormProvider, SubmitHandler } from "react-hook-form";
import { useAppContext } from "../../../../AppContext";
import { SetStateAction } from "react";
import { useSelectStudioForm } from "../hooks/useSelectStudioForm";
import { DefaultButton } from "../../button/defaultButton/DefaultButton";
import { ISelectStudioFormModel } from "../models/selectStudioFormModel";
import { DefaultFormSelectField } from "../../forms/inputs/dropdown/DefaultFormSelectField";
import { nameof } from "ts-simple-nameof";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import {
  getDefaultRoutePath,
  routePaths,
} from "../../../infrastructure/routes/routePaths";

interface ISelectStudioFormProps {
  setShowSelectStudioDialog: (value: SetStateAction<boolean>) => void;
}

export const SelectStudioForm = ({
  setShowSelectStudioDialog,
}: ISelectStudioFormProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { userStudios, requestStudioSwitch, currentUser, privateRoutes } =
    useAppContext();

  const form = useSelectStudioForm(userStudios);

  // The login page (it holds the page to return to after logging in) and a private page the
  // user opened, e.g. an email link, stay; anywhere else the user starts from their home page.
  const keepsCurrentPage =
    !!matchPath(routePaths.login, location.pathname) ||
    privateRoutes.some((route) => !!matchPath(route.path, location.pathname));

  const onSave: SubmitHandler<ISelectStudioFormModel> = async (data) => {
    requestStudioSwitch(data.selectedStudioId, () => {
      setShowSelectStudioDialog(false);
      if (!keepsCurrentPage) {
        navigate(getDefaultRoutePath(currentUser));
      }
    });
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSave)} className={styles.root}>
        <DefaultFormSelectField
          label="Обект"
          width="100%"
          name={nameof<ISelectStudioFormModel>((x) => x.selectedStudioId)}
          options={userStudios}
          includeId={false}
          required
        />
        <DefaultButton
          label={"Избери"}
          type="submit"
          disabled={form.watch("selectedStudioId") === 0}
        />
      </form>
    </FormProvider>
  );
};
